export var SubscriptionPlan;
(function (SubscriptionPlan) {
    SubscriptionPlan["STARTER"] = "STARTER";
    SubscriptionPlan["PROFESSIONAL"] = "PROFESSIONAL";
    SubscriptionPlan["FM_P2"] = "FM_P2";
})(SubscriptionPlan || (SubscriptionPlan = {}));
export var SiteType;
(function (SiteType) {
    SiteType["RETAIL"] = "RETAIL";
    SiteType["OFFICE"] = "OFFICE";
    SiteType["WAREHOUSE"] = "WAREHOUSE";
    SiteType["RESTAURANT"] = "RESTAURANT";
    SiteType["RESIDENTIAL"] = "RESIDENTIAL";
    SiteType["INDUSTRIAL"] = "INDUSTRIAL";
    SiteType["OTHER"] = "OTHER";
})(SiteType || (SiteType = {}));
export var SiteStatus;
(function (SiteStatus) {
    SiteStatus["ACTIVE"] = "ACTIVE";
    SiteStatus["MAINTENANCE"] = "MAINTENANCE";
    SiteStatus["INACTIVE"] = "INACTIVE";
    SiteStatus["CLOSED"] = "CLOSED";
})(SiteStatus || (SiteStatus = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["INACTIVE"] = "INACTIVE";
    UserStatus["SUSPENDED"] = "SUSPENDED";
    UserStatus["INVITED"] = "INVITED";
})(UserStatus || (UserStatus = {}));
/** `details.reason` of a 401 the API answers to a verified token it still refuses. */
export var AuthRefusalReason;
(function (AuthRefusalReason) {
    AuthRefusalReason["ORGANIZATION_INACTIVE"] = "organization_inactive";
})(AuthRefusalReason || (AuthRefusalReason = {}));
export var UserRole;
(function (UserRole) {
    UserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
    UserRole["ADMIN"] = "ADMIN";
    UserRole["FACILITY_MANAGER"] = "FACILITY_MANAGER";
    UserRole["VIEWER"] = "VIEWER";
    UserRole["TECHNICIAN"] = "TECHNICIAN";
})(UserRole || (UserRole = {}));
export const PaymentDelays = {
    '15': '15',
    '30': '30',
    '45': '45',
    '60': '60',
};
export var BusinessModels;
(function (BusinessModels) {
    BusinessModels["B2B"] = "b2b";
    BusinessModels["B2BB2c"] = "b2b2c";
})(BusinessModels || (BusinessModels = {}));
export var CompanyType;
(function (CompanyType) {
    CompanyType["SARL"] = "SARL";
    CompanyType["SA"] = "SA";
    CompanyType["SAS"] = "SAS";
    CompanyType["SASU"] = "SASU";
    CompanyType["EURL"] = "EURL";
    /**
     * Association (loi 1901 / cultuelle). A real client shape, not a placeholder: the
     * first one onboarded is a religious association managing 67 apartments, and
     * before this value existed the create-organization form left no truthful choice.
     * Deliberately generic — 1901 vs 1905 is not a distinction any code branches on.
     */
    CompanyType["ASSOCIATION"] = "ASSOCIATION";
    /** Auto-Entrepreneur (micro-entrepreneur) — technician-only forme juridique. */
    CompanyType["AE"] = "AE";
})(CompanyType || (CompanyType = {}));
/**
 * Legal forms (forme juridique) selectable for ORGANIZATIONS.
 * Excludes AE: organizations cannot be Auto-Entrepreneurs — AE is a
 * technician-only forme juridique (see issue #1420). Technician forms offer the
 * full `CompanyType` enum; org forms MUST derive their options from this subset
 * so AE never leaks into org onboarding / creation / settings.
 */
export const ORGANIZATION_COMPANY_TYPES = [
    CompanyType.SARL,
    CompanyType.SA,
    CompanyType.SAS,
    CompanyType.SASU,
    CompanyType.EURL,
    CompanyType.ASSOCIATION,
];
export var InvoiceContactType;
(function (InvoiceContactType) {
    InvoiceContactType["USER"] = "user";
    InvoiceContactType["EXTERNAL"] = "external";
})(InvoiceContactType || (InvoiceContactType = {}));
export var BillingEntityType;
(function (BillingEntityType) {
    BillingEntityType["ORGANIZATION"] = "organization";
    BillingEntityType["SITE"] = "site";
    BillingEntityType["CUSTOMER"] = "customer";
})(BillingEntityType || (BillingEntityType = {}));
export var AddressSource;
(function (AddressSource) {
    AddressSource["CUSTOMER"] = "custom";
    AddressSource["ORGANIZATION"] = "organization";
    AddressSource["SITE"] = "site";
})(AddressSource || (AddressSource = {}));
export var MaintenanceType;
(function (MaintenanceType) {
    MaintenanceType["PREVENTIVE"] = "preventive";
    MaintenanceType["CURATIVE"] = "curative";
    MaintenanceType["PREVENTIVE_CURATIVE"] = "preventive_curative";
})(MaintenanceType || (MaintenanceType = {}));
export var EquipmentCondition;
(function (EquipmentCondition) {
    EquipmentCondition["GOOD"] = "good";
    EquipmentCondition["FAIR"] = "fair";
    EquipmentCondition["POOR"] = "poor";
    EquipmentCondition["CRITICAL"] = "critical";
})(EquipmentCondition || (EquipmentCondition = {}));
export var EquipmentOperability;
(function (EquipmentOperability) {
    EquipmentOperability["FUNCTIONAL"] = "functional";
    EquipmentOperability["PARTIAL"] = "partial";
    EquipmentOperability["NON_FUNCTIONAL"] = "non_functional";
})(EquipmentOperability || (EquipmentOperability = {}));
export var EquipmentCriticality;
(function (EquipmentCriticality) {
    EquipmentCriticality["LOW"] = "low";
    EquipmentCriticality["MEDIUM"] = "medium";
    EquipmentCriticality["HIGH"] = "high";
    EquipmentCriticality["CRITICAL"] = "critical";
})(EquipmentCriticality || (EquipmentCriticality = {}));
export var EquipmentStatus;
(function (EquipmentStatus) {
    EquipmentStatus["ACTIVE"] = "active";
    EquipmentStatus["INACTIVE"] = "inactive";
    EquipmentStatus["MAINTENANCE"] = "maintenance";
    EquipmentStatus["RETIRED"] = "retired";
})(EquipmentStatus || (EquipmentStatus = {}));
export var JobType;
(function (JobType) {
    JobType["LOCKSMITH"] = "locksmith";
    JobType["PLUMBING"] = "plumbing";
    JobType["ELECTRICITY"] = "electricity";
    JobType["HEATING"] = "heating";
    JobType["GLAZING"] = "glazing";
    JobType["ROLLER_SHUTTER"] = "roller_shutter";
    JobType["DRAIN_CLEANING"] = "drain_cleaning";
    JobType["SEPTIC_TANK"] = "septic_tank";
    JobType["HYDRO_CLEANING"] = "hydro_cleaning";
    JobType["METAL_CURTAIN"] = "metal_curtain";
    JobType["THREE_D"] = "3d";
    JobType["GENERAL_WORKS"] = "general_works";
    JobType["LEAK_DETECTION"] = "leak_detection";
    JobType["SAFE"] = "safe";
})(JobType || (JobType = {}));
/**
 * Reusable equipment catalog a SUPER_ADMIN installs into an organization
 * (#2761). A catalog choice only — unrelated to {@link BusinessModels}, and it
 * implies no site mode, billing model or intervention type.
 */
export var EquipmentCatalogProfile;
(function (EquipmentCatalogProfile) {
    EquipmentCatalogProfile["B2B"] = "b2b";
    EquipmentCatalogProfile["B2C"] = "b2c";
})(EquipmentCatalogProfile || (EquipmentCatalogProfile = {}));
export var SiteContactType;
(function (SiteContactType) {
    SiteContactType["USER"] = "user";
    SiteContactType["EXTERNAL"] = "external";
})(SiteContactType || (SiteContactType = {}));
export var SiteAccessLevel;
(function (SiteAccessLevel) {
    SiteAccessLevel["READ"] = "read";
    SiteAccessLevel["WRITE"] = "write";
    SiteAccessLevel["ADMIN"] = "admin";
})(SiteAccessLevel || (SiteAccessLevel = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType["AVATAR"] = "avatar";
    DocumentType["INVOICE"] = "invoice";
    DocumentType["QUOTE"] = "quote";
    DocumentType["PHOTOS_BEFORE_INTERVENTION"] = "photos_before_intervention";
    DocumentType["PHOTOS_AFTER_INTERVENTION"] = "photos_after_intervention";
    DocumentType["PHOTOS"] = "photos";
    DocumentType["MANUAL"] = "manual";
    DocumentType["CERTIFICATE"] = "certificate";
    DocumentType["WARRANTY"] = "warranty";
    DocumentType["CONTRACT"] = "contract";
    DocumentType["TECHNICAL_SPEC"] = "technical_spec";
    DocumentType["SAFETY_DOC"] = "safety_doc";
    DocumentType["ACCESS_PLAN"] = "access_plan";
    DocumentType["MAINTENANCE_LOG"] = "maintenance_log";
    DocumentType["COMPLIANCE"] = "compliance";
    DocumentType["OTHER"] = "other";
    // Technician-specific document types
    DocumentType["IDENTITY"] = "identity";
    DocumentType["URSSAF"] = "urssaf";
    DocumentType["INSEE"] = "insee";
    DocumentType["TAX"] = "tax";
    DocumentType["INSURANCE"] = "insurance";
    DocumentType["FOREIGN_EMPLOYEES"] = "foreign_employees";
    DocumentType["HONOR_ATTESTATION"] = "honor_attestation";
})(DocumentType || (DocumentType = {}));
export var DocumentAccessLevel;
(function (DocumentAccessLevel) {
    DocumentAccessLevel["PUBLIC"] = "public";
    DocumentAccessLevel["INTERNAL"] = "internal";
    DocumentAccessLevel["RESTRICTED"] = "restricted";
    DocumentAccessLevel["CONFIDENTIAL"] = "confidential";
})(DocumentAccessLevel || (DocumentAccessLevel = {}));
/**
 * Who may read a note. `all` is the org-facing default; the two restricted
 * tiers are written by Depanneo staff only (today `UserRole.SUPER_ADMIN` —
 * see #1498 for the internal-role split).
 */
export var NoteAudience;
(function (NoteAudience) {
    NoteAudience["ALL"] = "all";
    NoteAudience["DEPANNEO_TECHNICIAN"] = "depanneo_technician";
    NoteAudience["DEPANNEO"] = "depanneo";
})(NoteAudience || (NoteAudience = {}));
export var EntityType;
(function (EntityType) {
    EntityType["ORGANIZATION"] = "organization";
    EntityType["SITE"] = "site";
    EntityType["EQUIPMENT"] = "equipment";
    EntityType["INTERVENTION"] = "intervention";
    EntityType["INTERVENTION_DISPUTE"] = "intervention_dispute";
    EntityType["TECHNICIAN"] = "technician";
    EntityType["USER"] = "user";
    EntityType["INVOICE"] = "invoice";
    EntityType["QUOTE"] = "quote";
})(EntityType || (EntityType = {}));
export const SEARCH_DOMAINS = [
    'intervention',
    'site',
    'equipment',
    'technician',
];
export var InterventionType;
(function (InterventionType) {
    InterventionType["CURATIVE"] = "curative";
    InterventionType["PREVENTIVE"] = "preventive";
})(InterventionType || (InterventionType = {}));
export var InterventionStatus;
(function (InterventionStatus) {
    InterventionStatus["DRAFT"] = "draft";
    InterventionStatus["AWAITING_QUOTE"] = "awaiting_quote";
    InterventionStatus["AWAITING_VALIDATION"] = "awaiting_validation";
    InterventionStatus["AWAITING_REVISION"] = "awaiting_revision";
    InterventionStatus["QUOTE_DECLINED"] = "quote_declined";
    InterventionStatus["AWAITING_ASSIGNMENT"] = "awaiting_assignment";
    /**
     * A technician is assigned but the passage date is still to be agreed
     * directly with the on-site contact (#1688). Reached only when the
     * intervention was created WITHOUT a `requestedDate`; leaves for SCHEDULED
     * once the technician writes the agreed `scheduledDate`.
     */
    InterventionStatus["AWAITING_SCHEDULING"] = "awaiting_scheduling";
    InterventionStatus["SCHEDULED"] = "scheduled";
    InterventionStatus["DELAYED"] = "delayed";
    InterventionStatus["IN_PROGRESS"] = "in_progress";
    InterventionStatus["ON_HOLD"] = "on_hold";
    InterventionStatus["TO_RESCHEDULE"] = "to_reschedule";
    InterventionStatus["NEXT_VISIT_SCHEDULED"] = "next_visit_scheduled";
    InterventionStatus["COMPLETED"] = "completed";
    InterventionStatus["CLOSED"] = "closed";
    InterventionStatus["CANCELLED"] = "cancelled";
})(InterventionStatus || (InterventionStatus = {}));
/** French labels for intervention statuses. Shared between API and web. */
export const InterventionStatusLabelFR = {
    [InterventionStatus.DRAFT]: 'Brouillon',
    [InterventionStatus.AWAITING_QUOTE]: 'En attente de devis',
    [InterventionStatus.AWAITING_VALIDATION]: 'Devis à valider',
    [InterventionStatus.AWAITING_REVISION]: 'Devis à réviser',
    [InterventionStatus.QUOTE_DECLINED]: 'Devis refusé',
    [InterventionStatus.AWAITING_ASSIGNMENT]: 'En attente d\u2019assignation',
    [InterventionStatus.AWAITING_SCHEDULING]: 'En attente de planification',
    [InterventionStatus.SCHEDULED]: 'Programmée',
    [InterventionStatus.DELAYED]: 'Retardée',
    [InterventionStatus.IN_PROGRESS]: 'En cours',
    [InterventionStatus.ON_HOLD]: 'En attente',
    [InterventionStatus.TO_RESCHEDULE]: 'À reprogrammer',
    [InterventionStatus.NEXT_VISIT_SCHEDULED]: '2ème passage programmé',
    [InterventionStatus.COMPLETED]: 'Terminée',
    [InterventionStatus.CLOSED]: 'Clôturée',
    [InterventionStatus.CANCELLED]: 'Annulée',
};
/**
 * Passage has exactly TWO values and no scheduling-mode column (#1688): a real
 * date and time, or no date yet. These are the French renderings of the second
 * one, shared so the creation form, the lists, the details header, dispatch and
 * the outbound messages cannot drift into three different sentences.
 */
export const PASSAGE_TO_AGREE_LABEL_FR = 'À convenir directement avec le contact sur place';
/** Tight surfaces — a table cell, a list row — where the full sentence wraps. */
export const PASSAGE_TO_AGREE_SHORT_FR = 'À convenir';
/** The creation-form toggle that switches the passage to the date-less case. */
export const PASSAGE_TO_AGREE_OPTION_FR = 'Date et heure à convenir avec le contact sur place';
/**
 * The SMS / WhatsApp variable slot. Deliberately UNACCENTED, like the static
 * text of every template in `notifications/constants/sms-templates.ts`: one
 * non-GSM-7 character switches the whole SMS to UCS-2 and halves the segment
 * length.
 */
export const PASSAGE_TO_AGREE_MESSAGE_FR = 'a convenir sur place';
/**
 * The work is being done or has been, so a client invoice may be created against
 * it (#1529).
 *
 * Shared between API and web on purpose: two copies of that list is exactly how
 * the quote drawer's button drifted from « À faire ».
 *
 * **HALF THE RULE, NOT THE RULE.** The other half is
 * `interventions.completed_date`: a status says where the intervention is NOW,
 * and one that WAS completed and then moved on to a follow-up phase (report asks
 * for a devis → AWAITING_QUOTE → AWAITING_VALIDATION) is not in this set while
 * the date still proves the visit happened. `assertInterventionWorkIsDone`
 * (`apps/api/.../invoice-intervention-gate.ts`) accepts EITHER fact and owns the
 * production case that forced it; the web CTAs mirror both. Never gate on this
 * list alone — that refused a real 264 € invoice for work that was performed.
 *
 * CLOSED is in and that is deliberate: cancelling a paid invoice with an avoir
 * leaves the intervention CLOSED, and a COMPLETED-only rule would make the
 * replacement invoice impossible to create — a refusal with no remedy. Same
 * predicate `InvoicesService.payStandardAndCloseIntervention` and the
 * reconciliation service already use for "the job is done".
 *
 * NOT the same list as `INVOICEABLE_INTERVENTION_STATUSES`
 * (`apps/api/.../invoices.repository.ts`), which drives the « À faire » WORK
 * QUEUE and is COMPLETED-only — a closed intervention is billable-in-principle
 * but has nothing left to do. Do not collapse the two.
 */
export const BILLABLE_INTERVENTION_STATUSES = [
    InterventionStatus.COMPLETED,
    InterventionStatus.CLOSED,
];
/**
 * Devis-phase statuses where a quote may be PRESENTED to the client — used by
 * the back-office curation `share()` (#1188): a SA may share onto an
 * AWAITING_QUOTE intervention, and AWAITING_VALIDATION is included so several
 * competing quotes can be presented while one already awaits the client;
 * AWAITING_REVISION / QUOTE_DECLINED let a re-share resume the loop.
 * NOTE: the external technician `/singledevis` quote routes are intentionally
 * NOT gated on this — they stay on AWAITING_QUOTE (stable osApp contract, R22).
 */
export const QUOTE_COLLECTION_STATUSES = [
    InterventionStatus.AWAITING_QUOTE,
    InterventionStatus.AWAITING_VALIDATION,
    InterventionStatus.AWAITING_REVISION,
    InterventionStatus.QUOTE_DECLINED,
];
/**
 * NOT active work on the dashboard: drafts, cancellations, the closed
 * terminals and the parked states (ON_HOLD, QUOTE_DECLINED) per #1264. The
 * « Interventions actives » metric counts every OTHER status, and the
 * pipeline card shows one stage per other status, so the two agree (#2420).
 * An exclusion set, so a new in-flight status is counted by default.
 */
export const DASHBOARD_INACTIVE_INTERVENTION_STATUSES = [
    InterventionStatus.DRAFT,
    InterventionStatus.CANCELLED,
    InterventionStatus.COMPLETED,
    InterventionStatus.CLOSED,
    InterventionStatus.ON_HOLD,
    InterventionStatus.QUOTE_DECLINED,
];
export var PriorityLevel;
(function (PriorityLevel) {
    PriorityLevel["CRITICAL"] = "critical";
    PriorityLevel["HIGH"] = "high";
    PriorityLevel["NORMAL"] = "normal";
    PriorityLevel["LOW"] = "low";
})(PriorityLevel || (PriorityLevel = {}));
/** Devis follow-up intent submitted by a technician after a completed visit. */
export var QuoteRequestType;
(function (QuoteRequestType) {
    QuoteRequestType["LEFT_ONSITE"] = "left_onsite";
    QuoteRequestType["TO_MAKE"] = "to_make";
})(QuoteRequestType || (QuoteRequestType = {}));
/** French labels for quote-request intents. Shared between API and web. */
export const QuoteRequestTypeLabelFR = {
    [QuoteRequestType.LEFT_ONSITE]: 'Devis laissé sur place',
    [QuoteRequestType.TO_MAKE]: 'Devis à établir',
};
/**
 * Three-way completion state a technician records when closing a visit.
 * Mirrors the completion state collected by the technician mobile app
 * (depanneoApp). Stored as a plain varchar on
 * `intervention_reports.completion_state` (varchar-for-small-enum precedent of
 * `job_type`, no pgEnum).
 */
export var InterventionCompletionState;
(function (InterventionCompletionState) {
    InterventionCompletionState["COMPLETED"] = "completed";
    InterventionCompletionState["SUITE_PREVUE"] = "suite_prevue";
    InterventionCompletionState["NOT_PERFORMED"] = "not_performed";
})(InterventionCompletionState || (InterventionCompletionState = {}));
/** French labels for report completion states. Shared between API and web. */
export const InterventionCompletionStateLabelFR = {
    [InterventionCompletionState.COMPLETED]: 'Terminée',
    [InterventionCompletionState.SUITE_PREVUE]: 'Suite prévue',
    [InterventionCompletionState.NOT_PERFORMED]: 'Non réalisée',
};
/**
 * Follow-up intent recorded on a report when a visit needs a suite (completion
 * state = suite_prevue). Mirrors the follow-up block collected by the
 * technician mobile app. Persisted inside `intervention_reports.followup`
 * (jsonb) — see the `ReportFollowup` type in intervention-types.
 */
export var InterventionFollowupChoice;
(function (InterventionFollowupChoice) {
    InterventionFollowupChoice["RETURN_SCHEDULED"] = "return_scheduled";
    InterventionFollowupChoice["QUOTE_LEFT_ONSITE"] = "quote_left_onsite";
    InterventionFollowupChoice["QUOTE_TO_MAKE"] = "quote_to_make";
    InterventionFollowupChoice["OTHER_FOLLOWUP"] = "other_followup";
})(InterventionFollowupChoice || (InterventionFollowupChoice = {}));
/** French labels for report follow-up choices. Shared between API and web. */
export const InterventionFollowupChoiceLabelFR = {
    [InterventionFollowupChoice.RETURN_SCHEDULED]: 'Nouveau passage programmé',
    [InterventionFollowupChoice.QUOTE_LEFT_ONSITE]: 'Devis laissé sur place',
    [InterventionFollowupChoice.QUOTE_TO_MAKE]: 'Devis à établir',
    [InterventionFollowupChoice.OTHER_FOLLOWUP]: 'Autre suite',
};
export var OnHoldReason;
(function (OnHoldReason) {
    OnHoldReason["CLIENT_REQUEST"] = "client_request";
    OnHoldReason["PARTS_UNAVAILABLE"] = "parts_unavailable";
    OnHoldReason["WEATHER"] = "weather";
    OnHoldReason["ADMINISTRATIVE"] = "administrative";
    OnHoldReason["OTHER"] = "other";
})(OnHoldReason || (OnHoldReason = {}));
/** French labels for the on-hold reasons. Shared by the hold dialog and the activity feed. */
export const OnHoldReasonLabelFR = {
    [OnHoldReason.CLIENT_REQUEST]: 'Demande du client',
    [OnHoldReason.PARTS_UNAVAILABLE]: 'Pièces indisponibles',
    [OnHoldReason.WEATHER]: 'Conditions météo',
    [OnHoldReason.ADMINISTRATIVE]: 'Raison administrative',
    [OnHoldReason.OTHER]: 'Autre',
};
/**
 * Why dispatch could not assign a technician to an AWAITING_ASSIGNMENT
 * intervention. Persisted on `interventions.dispatch_failure_reason` alongside
 * `dispatch_failed_at` — a flag layered on AWAITING_ASSIGNMENT, NOT a status.
 */
export var DispatchFailureReason;
(function (DispatchFailureReason) {
    /** Zero eligible technicians matched from the start. */
    DispatchFailureReason["NO_MATCH"] = "no_match";
    /** Every notified technician refused / all waves exhausted. */
    DispatchFailureReason["WAVE_EXHAUSTED"] = "wave_exhausted";
})(DispatchFailureReason || (DispatchFailureReason = {}));
/** French labels for dispatch-failure reasons. Shared between API and web. */
export const DispatchFailureReasonLabelFR = {
    [DispatchFailureReason.NO_MATCH]: 'Aucun artisan éligible trouvé',
    [DispatchFailureReason.WAVE_EXHAUSTED]: 'Tous les artisans notifiés ont refusé',
};
export var DisputeCategory;
(function (DisputeCategory) {
    DisputeCategory["TECHNICIAN_BEHAVIOR"] = "technician_behavior";
    DisputeCategory["WORK_QUALITY"] = "work_quality";
    DisputeCategory["BILLING_ISSUE"] = "billing_issue";
    DisputeCategory["DELAY"] = "delay";
    DisputeCategory["COMMUNICATION"] = "communication";
    DisputeCategory["OTHER"] = "other";
})(DisputeCategory || (DisputeCategory = {}));
/** French labels for dispute categories. Shared between API and web. */
export const DisputeCategoryLabelFR = {
    [DisputeCategory.TECHNICIAN_BEHAVIOR]: "Comportement de l'intervenant",
    [DisputeCategory.WORK_QUALITY]: 'Qualité du travail',
    [DisputeCategory.BILLING_ISSUE]: 'Problème de facturation',
    [DisputeCategory.DELAY]: 'Retard',
    [DisputeCategory.COMMUNICATION]: 'Communication',
    [DisputeCategory.OTHER]: 'Autre',
};
export var DisputeStatusFilter;
(function (DisputeStatusFilter) {
    DisputeStatusFilter["OPEN"] = "open";
    DisputeStatusFilter["RESOLVED"] = "resolved";
    DisputeStatusFilter["ALL"] = "all";
})(DisputeStatusFilter || (DisputeStatusFilter = {}));
export var TechnicianStatus;
(function (TechnicianStatus) {
    TechnicianStatus["PENDING_ACTIVATION"] = "pending_activation";
    TechnicianStatus["ACTIVE"] = "active";
    TechnicianStatus["INACTIVE"] = "inactive";
    TechnicianStatus["SUSPENDED"] = "suspended";
    TechnicianStatus["DEACTIVATED"] = "deactivated";
})(TechnicianStatus || (TechnicianStatus = {}));
export var ZoneType;
(function (ZoneType) {
    ZoneType["POSTAL_CODE"] = "postal_code";
    ZoneType["DEPARTMENT"] = "department";
})(ZoneType || (ZoneType = {}));
export var AvailabilityType;
(function (AvailabilityType) {
    AvailabilityType["WEEKLY_SCHEDULE"] = "weekly_schedule";
    AvailabilityType["UNAVAILABILITY_PERIOD"] = "unavailability_period";
    AvailabilityType["EXCEPTION"] = "exception";
})(AvailabilityType || (AvailabilityType = {}));
export var AcceptedPaymentMethods;
(function (AcceptedPaymentMethods) {
    AcceptedPaymentMethods["CASH"] = "cash";
    AcceptedPaymentMethods["DEBIT_CARD"] = "debit_card";
    AcceptedPaymentMethods["CREDIT_CARD"] = "credit_card";
    AcceptedPaymentMethods["CHECK"] = "check";
    AcceptedPaymentMethods["WIRE_TRANSFER"] = "wire_transfer";
    AcceptedPaymentMethods["BANK_TRANSFER"] = "bank_transfer";
    AcceptedPaymentMethods["SEPA_DIRECT_DEBIT"] = "sepa_direct_debit";
    AcceptedPaymentMethods["APPLE_PAY"] = "apple_pay";
    AcceptedPaymentMethods["GOOGLE_PAY"] = "google_pay";
})(AcceptedPaymentMethods || (AcceptedPaymentMethods = {}));
export var SyncStatus;
(function (SyncStatus) {
    SyncStatus["PENDING"] = "pending";
    SyncStatus["SYNCED"] = "synced";
    SyncStatus["CONFLICT"] = "conflict";
    SyncStatus["FAILED"] = "failed";
})(SyncStatus || (SyncStatus = {}));
export var UnavailabilityReason;
(function (UnavailabilityReason) {
    UnavailabilityReason["VACATION"] = "vacation";
    UnavailabilityReason["TRAINING"] = "training";
    UnavailabilityReason["ILLNESS"] = "illness";
    UnavailabilityReason["PERSONAL"] = "personal";
    UnavailabilityReason["OTHER"] = "other";
})(UnavailabilityReason || (UnavailabilityReason = {}));
/** French labels for a technician's unavailability-period reason. Shared between API and web. */
export const UnavailabilityReasonLabelFR = {
    [UnavailabilityReason.VACATION]: 'En congés',
    [UnavailabilityReason.TRAINING]: 'En formation',
    [UnavailabilityReason.ILLNESS]: 'En arrêt maladie',
    [UnavailabilityReason.PERSONAL]: 'Absence personnelle',
    [UnavailabilityReason.OTHER]: 'Indisponible',
};
export var TechnicianContactRole;
(function (TechnicianContactRole) {
    TechnicianContactRole["PRIMARY"] = "primary";
    TechnicianContactRole["SECONDARY"] = "secondary";
    TechnicianContactRole["OPERATIONAL"] = "operational";
    TechnicianContactRole["EMERGENCY"] = "emergency";
    TechnicianContactRole["BILLING"] = "billing";
})(TechnicianContactRole || (TechnicianContactRole = {}));
export var TechnicianFlagType;
(function (TechnicianFlagType) {
    TechnicianFlagType["PROBLEMATIC"] = "problematic";
    TechnicianFlagType["MONITORED"] = "monitored";
    TechnicianFlagType["BLACKLISTED"] = "blacklisted";
    TechnicianFlagType["HIGH_PERFORMER"] = "high_performer";
    TechnicianFlagType["NEEDS_TRAINING"] = "needs_training";
    TechnicianFlagType["PROBATION"] = "probation";
    TechnicianFlagType["B2B"] = "b2b";
    TechnicianFlagType["EXCLUSIVE"] = "exclusif";
    TechnicianFlagType["REQUIRES_APPROVAL"] = "requires_approval";
})(TechnicianFlagType || (TechnicianFlagType = {}));
export var TechnicianContractStatus;
(function (TechnicianContractStatus) {
    TechnicianContractStatus["SIGNED"] = "signed";
    TechnicianContractStatus["SENT"] = "sent";
})(TechnicianContractStatus || (TechnicianContractStatus = {}));
export const TechnicianDocumentType = {
    CONTRACT: DocumentType.CONTRACT,
    IDENTITY: DocumentType.IDENTITY,
    URSSAF: DocumentType.URSSAF,
    INSEE: DocumentType.INSEE,
    TAX: DocumentType.TAX,
    INSURANCE: DocumentType.INSURANCE,
    FOREIGN_EMPLOYEES: DocumentType.FOREIGN_EMPLOYEES,
    HONOR_ATTESTATION: DocumentType.HONOR_ATTESTATION,
    COMPLIANCE: DocumentType.COMPLIANCE,
};
export const REQUIRED_TECHNICIAN_DOCUMENT_TYPES = [
    TechnicianDocumentType.CONTRACT,
    TechnicianDocumentType.IDENTITY,
    TechnicianDocumentType.URSSAF,
    TechnicianDocumentType.INSEE,
    TechnicianDocumentType.TAX,
    TechnicianDocumentType.INSURANCE,
];
export const OPTIONAL_TECHNICIAN_DOCUMENT_TYPES = [
    TechnicianDocumentType.FOREIGN_EMPLOYEES,
    TechnicianDocumentType.HONOR_ATTESTATION,
];
export var TechnicianInterventionActionType;
(function (TechnicianInterventionActionType) {
    TechnicianInterventionActionType["NOTIFIED"] = "notified";
    TechnicianInterventionActionType["VIEWED"] = "viewed";
    TechnicianInterventionActionType["ACCEPTED"] = "accepted";
    TechnicianInterventionActionType["REJECTED"] = "rejected";
    TechnicianInterventionActionType["STARTED"] = "started";
    TechnicianInterventionActionType["COMPLETED"] = "completed";
    TechnicianInterventionActionType["CANCELED"] = "canceled";
    TechnicianInterventionActionType["RESCHEDULED"] = "rescheduled";
})(TechnicianInterventionActionType || (TechnicianInterventionActionType = {}));
/**
 * Technician actions that bar further dispatch on the SAME intervention (#1685).
 * The two keep distinct action types for audit and UI labels — only dispatch
 * treats them alike.
 */
export const DISPATCH_EXCLUDING_ACTIONS = [
    TechnicianInterventionActionType.REJECTED,
    TechnicianInterventionActionType.CANCELED,
];
export var InvoiceType;
(function (InvoiceType) {
    InvoiceType["STANDARD"] = "standard";
    InvoiceType["DOWN_PAYMENT"] = "down_payment";
    InvoiceType["CREDIT_NOTE"] = "credit_note";
    // Depanneo → technician commission invoice (#1211). Billed party is the
    // technician; amount = paid client invoice TTC × snapshotted commission %.
    InvoiceType["COMMISSION"] = "commission";
})(InvoiceType || (InvoiceType = {}));
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["DRAFT"] = "draft";
    InvoiceStatus["SENT"] = "sent";
    InvoiceStatus["PAID"] = "paid";
    InvoiceStatus["CANCELLED"] = "cancelled";
})(InvoiceStatus || (InvoiceStatus = {}));
/**
 * French labels for invoice statuses. Shared between API and web.
 * Enum values only — the display-only synthesized states (overdue,
 * payment-declared) are labelled web-side, see apps/web constants/invoices.ts.
 */
export const InvoiceStatusLabelFR = {
    [InvoiceStatus.DRAFT]: 'Brouillon',
    [InvoiceStatus.SENT]: 'Envoyée',
    [InvoiceStatus.PAID]: 'Payée',
    [InvoiceStatus.CANCELLED]: 'Annulée',
};
/**
 * Discriminator carried by the 400 that refuses an intervention write whose
 * `assignedUserIds` names a user outside the target organization (#1574).
 * Shared with the web so the French sentence listing the offending ids can be
 * shown verbatim: `getApiErrorMessage` only passes a 400 body through when its
 * `message` is an array, and most `BadRequestException` texts are English
 * developer strings — the discriminator is what proves this one is not.
 */
export const CROSS_ORG_ASSIGNEES_CLASSIFICATION = 'cross_org_assignees';
/**
 * Discriminator carried by the 400 that refuses a site re-point which would
 * change the zone the intervention's wall clocks are read in without the body
 * restating them (#1938). The stored digits cannot be re-read in the new zone
 * on the server's own authority: for a row imported from V1 they are an epoch
 * rendered in Paris, not a wall clock anyone typed, and nothing on the row
 * tells the two apart (PR #1948).
 *
 * `details.canRestateDate` says whether the caller can answer the refusal by
 * resending the write with `requestedDate`: `true` is the invitation to ask the
 * operator for it, `false` means only a SUPER_ADMIN could, or the column is one
 * no form exposes — show the message and stop. Without that second key the web
 * cannot tell them apart and falls back to « Veuillez réessayer », which is
 * wrong advice: retrying produces the identical refusal.
 */
export const CROSS_ZONE_SITE_MOVE_CLASSIFICATION = 'cross_zone_site_move';
export var ReconciliationClassification;
(function (ReconciliationClassification) {
    /** Matched STANDARD client invoice, ready to pay + close + commission. */
    ReconciliationClassification["READY"] = "ready";
    /** Matched DOWN_PAYMENT (acompte): mark paid only, no close/commission. */
    ReconciliationClassification["READY_DOWN_PAYMENT"] = "ready_down_payment";
    /** No invoice with this number (introuvable). */
    ReconciliationClassification["NOT_FOUND"] = "not_found";
    /** Token doesn't match the invoice-number format — hard-rejected (format invalide). */
    ReconciliationClassification["INVALID_FORMAT"] = "invalid_format";
    /** Resolvable but wrong series — AVO/CM rejected (mauvais type). */
    ReconciliationClassification["WRONG_TYPE"] = "wrong_type";
    /** Matched but a gate blocks it: no technician/rate, or not issued (bloquée). */
    ReconciliationClassification["BLOCKED"] = "blocked";
    /** Already paid with a live commission — nothing to do (déjà traitée). */
    ReconciliationClassification["ALREADY_PROCESSED"] = "already_processed";
})(ReconciliationClassification || (ReconciliationClassification = {}));
/** French exception labels surfaced in the preview/report (#1280). */
export const ReconciliationClassificationLabelFR = {
    [ReconciliationClassification.READY]: 'Prête',
    [ReconciliationClassification.READY_DOWN_PAYMENT]: 'Acompte',
    [ReconciliationClassification.NOT_FOUND]: 'introuvable',
    [ReconciliationClassification.INVALID_FORMAT]: 'format invalide',
    [ReconciliationClassification.WRONG_TYPE]: 'mauvais type',
    [ReconciliationClassification.BLOCKED]: 'bloquée',
    [ReconciliationClassification.ALREADY_PROCESSED]: 'déjà traitée',
};
/** Per-item result of an execute run (#1280). */
export var ReconciliationOutcome;
(function (ReconciliationOutcome) {
    /** Persisted but not yet processed by the background worker (#1281 async). */
    ReconciliationOutcome["PENDING"] = "pending";
    ReconciliationOutcome["SUCCEEDED"] = "succeeded";
    ReconciliationOutcome["FAILED"] = "failed";
    /** Already fully processed — counted as a (no-op) success for idempotency. */
    ReconciliationOutcome["SKIPPED"] = "skipped";
})(ReconciliationOutcome || (ReconciliationOutcome = {}));
/**
 * Run-level lifecycle for an async reconciliation (#1281). The batch is
 * persisted, then processed out of the request cycle by a background worker.
 */
export var ReconciliationRunStatus;
(function (ReconciliationRunStatus) {
    /** Persisted, items pending, worker not started yet. */
    ReconciliationRunStatus["QUEUED"] = "queued";
    /** Worker is processing items (heartbeat keeps it alive). */
    ReconciliationRunStatus["RUNNING"] = "running";
    /** All items processed (succeeded/failed/skipped). */
    ReconciliationRunStatus["COMPLETED"] = "completed";
    /** Aborted before completion (catastrophic worker error). */
    ReconciliationRunStatus["FAILED"] = "failed";
})(ReconciliationRunStatus || (ReconciliationRunStatus = {}));
export var QuoteStatus;
(function (QuoteStatus) {
    QuoteStatus["PENDING"] = "pending";
    QuoteStatus["VALIDATED"] = "validated";
    QuoteStatus["REVISION_REQUESTED"] = "revision_requested";
    QuoteStatus["DECLINED"] = "declined";
    QuoteStatus["SUPERSEDED"] = "superseded";
})(QuoteStatus || (QuoteStatus = {}));
/**
 * PDF generation state (#1417 Phase 2) — orthogonal to `QuoteStatus`: a
 * PENDING quote can be GENERATING/READY/FAILED; a VALIDATED/DECLINED/
 * SUPERSEDED quote keeps whatever generation status it last reached (no
 * retroactive changes). Uppercase values are a deliberate departure from
 * `QuoteStatus`'s lowercase convention — see `schema.ts`'s `quotes.generation_status`
 * CHECK constraint, which is the locked source of truth for these literals.
 */
export var QuoteGenerationStatus;
(function (QuoteGenerationStatus) {
    QuoteGenerationStatus["GENERATING"] = "GENERATING";
    QuoteGenerationStatus["READY"] = "READY";
    QuoteGenerationStatus["FAILED"] = "FAILED";
})(QuoteGenerationStatus || (QuoteGenerationStatus = {}));
/**
 * French labels for quote statuses. Shared between API and web.
 * Short client-facing form ("À valider", "À réviser"); the matching
 * intervention status adds the "Devis " prefix (see InterventionStatusLabelFR).
 */
export const QuoteStatusLabelFR = {
    [QuoteStatus.PENDING]: 'À valider',
    [QuoteStatus.VALIDATED]: 'Validé',
    [QuoteStatus.REVISION_REQUESTED]: 'À réviser',
    [QuoteStatus.DECLINED]: 'Refusé',
    [QuoteStatus.SUPERSEDED]: 'Remplacé',
};
export var VatRate;
(function (VatRate) {
    VatRate["EXEMPT"] = "0.00";
    VatRate["SUPER_REDUCED"] = "2.10";
    VatRate["REDUCED"] = "5.50";
    VatRate["INTERMEDIATE"] = "10.00";
    VatRate["STANDARD"] = "20.00";
})(VatRate || (VatRate = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["PERCENTAGE"] = "percentage";
    DiscountType["FIXED"] = "fixed";
})(DiscountType || (DiscountType = {}));
export var InterventionReportStatus;
(function (InterventionReportStatus) {
    InterventionReportStatus["DRAFT"] = "draft";
    InterventionReportStatus["PENDING_SIGNATURE"] = "pending_signature";
    InterventionReportStatus["COMPLETED"] = "completed";
})(InterventionReportStatus || (InterventionReportStatus = {}));
/**
 * Report PDF generation state (#1417 Phase 4) — orthogonal to
 * `InterventionReportStatus`: a COMPLETED report's PDF can be GENERATING (a web
 * content edit is re-rendering it), READY, or FAILED. Uppercase values match
 * `QuoteGenerationStatus`'s deliberate departure from the surrounding lowercase
 * convention; `schema.ts`'s `intervention_reports.pdf_generation_status` CHECK
 * constraint is the locked source of truth for these literals.
 */
export var ReportPdfGenerationStatus;
(function (ReportPdfGenerationStatus) {
    ReportPdfGenerationStatus["GENERATING"] = "GENERATING";
    ReportPdfGenerationStatus["READY"] = "READY";
    ReportPdfGenerationStatus["FAILED"] = "FAILED";
})(ReportPdfGenerationStatus || (ReportPdfGenerationStatus = {}));
export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["PENDING"] = "pending";
    NotificationStatus["SENT"] = "sent";
    NotificationStatus["DELIVERED"] = "delivered";
    NotificationStatus["FAILED"] = "failed";
    NotificationStatus["CANCELLED"] = "cancelled";
})(NotificationStatus || (NotificationStatus = {}));
export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["WHATSAPP"] = "whatsapp";
    NotificationChannel["SMS"] = "sms";
})(NotificationChannel || (NotificationChannel = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["DISPATCH"] = "dispatch";
    NotificationType["CONFIRMED"] = "confirmed";
    NotificationType["CANCELLED"] = "cancelled";
    NotificationType["REMINDER"] = "reminder";
    /** The assigned technician told of a new passage date (#2417). */
    NotificationType["RESCHEDULED"] = "rescheduled";
})(NotificationType || (NotificationType = {}));
/**
 * A channel the unified notification engine delivers on (#1659, ADR 0002 §1.4).
 *
 * Deliberately NOT the technician-dispatch `NotificationChannel` above: WhatsApp
 * and SMS stay outside the engine (their retry policy is a business rule, not a
 * transport concern — ADR 0002 "Scope"), so the two sets never merge.
 */
export var NotificationDeliveryChannel;
(function (NotificationDeliveryChannel) {
    NotificationDeliveryChannel["IN_APP"] = "in_app";
    NotificationDeliveryChannel["EMAIL"] = "email";
    NotificationDeliveryChannel["SLACK"] = "slack";
    NotificationDeliveryChannel["GENERIC_WEBHOOK"] = "generic_webhook";
})(NotificationDeliveryChannel || (NotificationDeliveryChannel = {}));
/**
 * Channel-INDEPENDENT delivery state (#1659, ADR 0002 §3). An adapter maps its
 * vendor's vocabulary into these and nothing else.
 *
 * `SENT` means the adapter ACCEPTED it — all any of our channels can promise
 * (Brevo returns a messageId, Slack returns 200, an in-app row is committed); no
 * state machine waits for a vendor callback. `EXHAUSTED` (attempts spent) is
 * deliberately distinct from `FAILED` (attempts remain): they demand opposite
 * operator responses, and EXHAUSTED is the only signal that a message was
 * silently given up on.
 */
export var NotificationDeliveryState;
(function (NotificationDeliveryState) {
    NotificationDeliveryState["PENDING"] = "pending";
    NotificationDeliveryState["SENDING"] = "sending";
    NotificationDeliveryState["SENT"] = "sent";
    NotificationDeliveryState["FAILED"] = "failed";
    NotificationDeliveryState["EXHAUSTED"] = "exhausted";
    NotificationDeliveryState["CANCELLED"] = "cancelled";
})(NotificationDeliveryState || (NotificationDeliveryState = {}));
/**
 * The LEGACY sender a delivery is migrating off (#1659, ADR 0002 §8). One
 * feature flag per member (`NOTIFICATIONS_ENGINE_<member>`), which is why the
 * value is carried per delivery: the flag is what decides whether the engine
 * delivered it or only shadowed it, and §8's deletion rule is stated per sender.
 *
 * A plain varchar column rather than a pg enum on purpose — the set SHRINKS as
 * legacy paths are deleted, and dropping a pg enum value is not expand-safe.
 */
export var NotificationSender;
(function (NotificationSender) {
    NotificationSender["IN_APP"] = "IN_APP";
    NotificationSender["INVOICE_EMAIL"] = "INVOICE_EMAIL";
    NotificationSender["OUTBOUND_CHANNEL"] = "OUTBOUND_CHANNEL";
    NotificationSender["CLIENT_EMAIL"] = "CLIENT_EMAIL";
})(NotificationSender || (NotificationSender = {}));
/**
 * How the `commission_percentage` frozen on an intervention was resolved (#1588).
 *
 * The resolver is TOTAL — every assignment freezes a percentage — so the source
 * records WHICH level answered. Ordered from most specific to least:
 * `ZONE_MATCH` (the geographic + job-type zone dispatch matched),
 * `SAME_JOB_TYPE` (highest active rate for the same trade, any geography),
 * `HIGHEST_RATE` (highest active rate across every trade),
 * `HARD_DEFAULT` (`COMMISSION_HARD_FALLBACK_PERCENTAGE`, no active zone at all).
 *
 * `SELF_BILLING_EXEMPT` is orthogonal and resolved FIRST: the assigned
 * technician is the same legal entity as the platform billing entity, so there
 * is nobody to invoice. It freezes `0.00` and no work zone.
 *
 * A plain varchar column rather than a pg enum: the column stays nullable for
 * historical rows whose resolution level cannot be reconstructed safely.
 */
export var CommissionRateSource;
(function (CommissionRateSource) {
    CommissionRateSource["ZONE_MATCH"] = "zone_match";
    CommissionRateSource["SAME_JOB_TYPE"] = "same_job_type";
    CommissionRateSource["HIGHEST_RATE"] = "highest_rate";
    CommissionRateSource["HARD_DEFAULT"] = "hard_default";
    CommissionRateSource["SELF_BILLING_EXEMPT"] = "self_billing_exempt";
    /** The V1 job's own rate, frozen by the V1 import (A11, #2660); never resolved at runtime. */
    CommissionRateSource["V1_IMPORT"] = "v1_import";
})(CommissionRateSource || (CommissionRateSource = {}));
/**
 * Ruled commission rate when the configuration can provide none (#1588): the
 * technician has no active, non-deleted work zone at all. Shared by the
 * application resolver (`findCommissionRateForAssignment`) and the B2B2C import
 * resolver (`resolveCommissionSnapshot`) so the two cannot drift. Stored as the
 * `numeric(5,2)` string the column takes.
 *
 * "No zone" never means in-house — that is the `SELF_BILLING_EXEMPT`
 * legal-identity test, and only that.
 */
export const COMMISSION_HARD_FALLBACK_PERCENTAGE = '20.00';
/**
 * How far an organization lets the devis decision engine act on its own (#1586).
 *
 * A ROLLOUT LADDER, ordered, and the ONE definition of that order — every rung
 * includes the powers of the rung below it. It is Depanneo's dial
 * (SUPER_ADMIN-only, and a Postgres invariant since migration 0179), separate
 * from `organizations.quoteAutoValidationOptIn`, which is the CLIENT's consent
 * to be decided for at all. WITHOUT that consent the opt-in CAPS this ladder at
 * `AUTO_SHARE` — it does not collapse it to `OFF`, because presenting a quote
 * decides nothing for the client. Resolved once, under a global env kill switch,
 * in `resolveQuoteAutoDecision`
 * (`apps/api/src/domains/quotes/decision/quote-auto-decision.gate.ts`), never
 * re-derived by a caller.
 *
 * `SUGGEST` acts on nothing: #1585 already scores every devis for a SUPER_ADMIN,
 * so the rung means « the engine has an opinion and a human still clicks » — the
 * auditable state an org sits in before it is trusted with `AUTO_SHARE`.
 *
 * A plain text column, not a pg enum: adding a rung to an enum is a migration
 * that cannot always run inside the migrator's single transaction.
 */
export var QuoteAutoDecisionMode;
(function (QuoteAutoDecisionMode) {
    /** Nothing automatic. The default, and what the kill switch collapses to. */
    QuoteAutoDecisionMode["OFF"] = "off";
    /** Score and display only — identical in EFFECT to `OFF` (#1585 already scores). */
    QuoteAutoDecisionMode["SUGGEST"] = "suggest";
    /** The machine may present a quote to the client; the client still decides. */
    QuoteAutoDecisionMode["AUTO_SHARE"] = "auto_share";
    /** The machine may also accept it on the client's behalf. */
    QuoteAutoDecisionMode["AUTO_VALIDATE"] = "auto_validate";
})(QuoteAutoDecisionMode || (QuoteAutoDecisionMode = {}));
/**
 * The ladder in order, weakest first. Callers compare RUNGS through this array
 * (`indexOf`), never by string — `'auto_share' < 'auto_validate'` is true by
 * accident of the alphabet and would silently invert the day a rung is renamed.
 */
export const QUOTE_AUTO_DECISION_MODE_LADDER = [
    QuoteAutoDecisionMode.OFF,
    QuoteAutoDecisionMode.SUGGEST,
    QuoteAutoDecisionMode.AUTO_SHARE,
    QuoteAutoDecisionMode.AUTO_VALIDATE,
];
